import { usePlayerStore } from "@/stores/playerStore";
import { useEffect, useState } from "react";

interface AnimatedLogoProps {
  className?: string;
  speed?: number; // Animation speed in ms
}

export function AnimatedLogo({
  className = "",
  speed = 500,
}: AnimatedLogoProps) {
  const { isPlaying } = usePlayerStore();
  const [activeGroup, setActiveGroup] = useState<number | null>(null);

  useEffect(() => {
    if (!isPlaying) {
      setActiveGroup(null);
      return;
    }

    // Animation logic
    let currentGroup = 1;
    const interval = setInterval(() => {
      setActiveGroup(currentGroup);
      currentGroup = (currentGroup % 4) + 1; // Cycle through groups 1-4
    }, speed);

    return () => clearInterval(interval);
  }, [isPlaying, speed]);

  return (
    <svg
      className={className}
      width="100%"
      height="100%"
      viewBox="0 0 1151 398"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2,
      }}
    >
      <g transform="matrix(1,0,0,1,-2383,-202)">
        <g
          id="Artboard1"
          transform="matrix(0.691834,0,0,0.404132,2294.13,88.9637)"
        >
          <rect
            x="129.42"
            y="280.083"
            width="1662.58"
            height="982.807"
            style={{ fill: "none" }}
          />

          {/* Text group - always visible */}
          <g
            id="text"
            transform="matrix(0.924266,0,0,1.58225,-314.701,-666.022)"
          >
            <g transform="matrix(879.291,0,0,879.291,500.979,1215.43)">
              <path
                d="M0.091,-0.691L0.009,-0.691L0.009,-0.609L0.091,-0.609L0.091,-0.691ZM0.491,-0.691L0.409,-0.691L0.409,-0.609L0.491,-0.609L0.491,-0.691ZM0.091,-0.591L0.009,-0.591L0.009,-0.509L0.091,-0.509L0.091,-0.591ZM0.491,-0.591L0.409,-0.591L0.409,-0.509L0.491,-0.509L0.491,-0.591ZM0.091,-0.491L0.009,-0.491L0.009,-0.409L0.091,-0.409L0.091,-0.491ZM0.491,-0.491L0.409,-0.491L0.409,-0.409L0.491,-0.409L0.491,-0.491ZM0.091,-0.391L0.009,-0.391L0.009,-0.309L0.091,-0.309L0.091,-0.391ZM0.291,-0.391L0.209,-0.391L0.209,-0.309L0.291,-0.309L0.291,-0.391ZM0.491,-0.391L0.409,-0.391L0.409,-0.309L0.491,-0.309L0.491,-0.391ZM0.091,-0.291L0.009,-0.291L0.009,-0.209L0.091,-0.209L0.091,-0.291ZM0.291,-0.291L0.209,-0.291L0.209,-0.209L0.291,-0.209L0.291,-0.291ZM0.491,-0.291L0.409,-0.291L0.409,-0.209L0.491,-0.209L0.491,-0.291ZM0.091,-0.191L0.009,-0.191L0.009,-0.109L0.091,-0.109L0.091,-0.191ZM0.191,-0.191L0.109,-0.191L0.109,-0.109L0.191,-0.109L0.191,-0.191ZM0.391,-0.191L0.309,-0.191L0.309,-0.109L0.391,-0.109L0.391,-0.191ZM0.491,-0.191L0.409,-0.191L0.409,-0.109L0.491,-0.109L0.491,-0.191ZM0.091,-0.091L0.009,-0.091L0.009,-0.009L0.091,-0.009L0.091,-0.091ZM0.491,-0.091L0.409,-0.091L0.409,-0.009L0.491,-0.009L0.491,-0.091Z"
                style={{ fillRule: "nonzero" }}
              />
            </g>
            <g transform="matrix(879.291,0,0,879.291,1028.55,1215.43)">
              <path
                d="M0.291,-0.691L0.209,-0.691L0.209,-0.609L0.291,-0.609L0.291,-0.691ZM0.391,-0.691L0.309,-0.691L0.309,-0.609L0.391,-0.609L0.391,-0.691ZM0.191,-0.591L0.109,-0.591L0.109,-0.509L0.191,-0.509L0.191,-0.591ZM0.491,-0.591L0.409,-0.591L0.409,-0.509L0.491,-0.509L0.491,-0.591ZM0.191,-0.491L0.109,-0.491L0.109,-0.409L0.191,-0.409L0.191,-0.491ZM0.091,-0.391L0.009,-0.391L0.009,-0.309L0.091,-0.309L0.091,-0.391ZM0.191,-0.391L0.109,-0.391L0.109,-0.309L0.191,-0.309L0.191,-0.391ZM0.291,-0.391L0.209,-0.391L0.209,-0.309L0.291,-0.309L0.291,-0.391ZM0.391,-0.391L0.309,-0.391L0.309,-0.309L0.391,-0.309L0.391,-0.391ZM0.191,-0.291L0.109,-0.291L0.109,-0.209L0.191,-0.209L0.191,-0.291ZM0.191,-0.191L0.109,-0.191L0.109,-0.109L0.191,-0.109L0.191,-0.191ZM0.191,-0.091L0.109,-0.091L0.109,-0.009L0.191,-0.009L0.191,-0.091Z"
                style={{ fillRule: "nonzero" }}
              />
            </g>
            <g transform="matrix(879.291,0,0,879.291,1556.11,1215.43)"></g>
          </g>

          {/* Animation group 4 - largest size */}
          <g
            id="anim-4"
            transform="matrix(0.924266,0,0,1.58225,-464.05,-666.022)"
            style={{
              opacity:
                !isPlaying || (activeGroup !== null && activeGroup >= 4)
                  ? 1
                  : 0,
              transition: "opacity 0.2s ease-in-out",
            }}
          >
            <path
              d="M1900.13,607.624L1827.59,607.624L1827.59,680.166L1900.13,680.166L1900.13,607.624ZM1812.21,695.554L1739.66,695.554L1739.66,768.095L1812.21,768.095L1812.21,695.554ZM1724.28,783.483L1651.74,783.483L1651.74,856.024L1724.28,856.024L1724.28,783.483ZM1724.28,871.412L1651.74,871.412L1651.74,943.953L1724.28,943.953L1724.28,871.412ZM1724.28,959.341L1651.74,959.341L1651.74,1031.88L1724.28,1031.88L1724.28,959.341ZM1812.21,1047.27L1739.66,1047.27L1739.66,1119.81L1812.21,1119.81L1812.21,1047.27ZM1900.13,1135.2L1827.59,1135.2L1827.59,1207.74L1900.13,1207.74L1900.13,1135.2Z"
              style={{ fillRule: "nonzero" }}
            />
            <path
              d="M2251.84,607.624L2179.3,607.624L2179.3,680.166L2251.84,680.166L2251.84,607.624ZM2339.77,695.554L2267.23,695.554L2267.23,768.095L2339.77,768.095L2339.77,695.554ZM2427.7,783.483L2355.16,783.483L2355.16,856.024L2427.7,856.024L2427.7,783.483ZM2427.7,871.412L2355.16,871.412L2355.16,943.953L2427.7,943.953L2427.7,871.412ZM2427.7,959.341L2355.16,959.341L2355.16,1031.88L2427.7,1031.88L2427.7,959.341ZM2339.77,1047.27L2267.23,1047.27L2267.23,1119.81L2339.77,1119.81L2339.77,1047.27ZM2251.84,1135.2L2179.3,1135.2L2179.3,1207.74L2251.84,1207.74L2251.84,1135.2Z"
              style={{ fillRule: "nonzero" }}
            />
          </g>

          {/* Animation group 3 - medium size */}
          <g
            id="anim-3"
            transform="matrix(0.577515,0,0,0.97062,241.573,-107.547)"
            style={{
              opacity:
                !isPlaying || (activeGroup !== null && activeGroup >= 3)
                  ? 1
                  : 0,
              transition: "opacity 0.2s ease-in-out",
            }}
          >
            <g>
              <path
                d="M1900.13,607.624L1827.59,607.624L1827.59,680.166L1900.13,680.166L1900.13,607.624ZM1812.21,695.554L1739.66,695.554L1739.66,768.095L1812.21,768.095L1812.21,695.554ZM1724.28,783.483L1651.74,783.483L1651.74,856.024L1724.28,856.024L1724.28,783.483ZM1724.28,871.412L1651.74,871.412L1651.74,943.953L1724.28,943.953L1724.28,871.412ZM1724.28,959.341L1651.74,959.341L1651.74,1031.88L1724.28,1031.88L1724.28,959.341ZM1812.21,1047.27L1739.66,1047.27L1739.66,1119.81L1812.21,1119.81L1812.21,1047.27ZM1900.13,1135.2L1827.59,1135.2L1827.59,1207.74L1900.13,1207.74L1900.13,1135.2Z"
                style={{ fillRule: "nonzero" }}
              />
              <path
                d="M2251.84,607.624L2179.3,607.624L2179.3,680.166L2251.84,680.166L2251.84,607.624ZM2339.77,695.554L2267.23,695.554L2267.23,768.095L2339.77,768.095L2339.77,695.554ZM2427.7,783.483L2355.16,783.483L2355.16,856.024L2427.7,856.024L2427.7,783.483ZM2427.7,871.412L2355.16,871.412L2355.16,943.953L2427.7,943.953L2427.7,871.412ZM2427.7,959.341L2355.16,959.341L2355.16,1031.88L2427.7,1031.88L2427.7,959.341ZM2339.77,1047.27L2267.23,1047.27L2267.23,1119.81L2339.77,1119.81L2339.77,1047.27ZM2251.84,1135.2L2179.3,1135.2L2179.3,1207.74L2251.84,1207.74L2251.84,1135.2Z"
                style={{ fillRule: "nonzero" }}
              />
            </g>
          </g>

          {/* Animation group 2 - small size */}
          <g
            id="anim-2"
            transform="matrix(0.276536,0,0,0.526679,855.485,295.411)"
            style={{
              opacity:
                !isPlaying || (activeGroup !== null && activeGroup >= 2)
                  ? 1
                  : 0,
              transition: "opacity 0.2s ease-in-out",
            }}
          >
            <g>
              <path
                d="M1900.13,607.624L1827.59,607.624L1827.59,680.166L1900.13,680.166L1900.13,607.624ZM1812.21,695.554L1739.66,695.554L1739.66,768.095L1812.21,768.095L1812.21,695.554ZM1724.28,783.483L1651.74,783.483L1651.74,856.024L1724.28,856.024L1724.28,783.483ZM1724.28,871.412L1651.74,871.412L1651.74,943.953L1724.28,943.953L1724.28,871.412ZM1724.28,959.341L1651.74,959.341L1651.74,1031.88L1724.28,1031.88L1724.28,959.341ZM1812.21,1047.27L1739.66,1047.27L1739.66,1119.81L1812.21,1119.81L1812.21,1047.27ZM1900.13,1135.2L1827.59,1135.2L1827.59,1207.74L1900.13,1207.74L1900.13,1135.2Z"
                style={{ fillRule: "nonzero" }}
              />
              <path
                d="M2251.84,607.624L2179.3,607.624L2179.3,680.166L2251.84,680.166L2251.84,607.624ZM2339.77,695.554L2267.23,695.554L2267.23,768.095L2339.77,768.095L2339.77,695.554ZM2427.7,783.483L2355.16,783.483L2355.16,856.024L2427.7,856.024L2427.7,783.483ZM2427.7,871.412L2355.16,871.412L2355.16,943.953L2427.7,943.953L2427.7,871.412ZM2427.7,959.341L2355.16,959.341L2355.16,1031.88L2427.7,1031.88L2427.7,959.341ZM2339.77,1047.27L2267.23,1047.27L2267.23,1119.81L2339.77,1119.81L2339.77,1047.27ZM2251.84,1135.2L2179.3,1135.2L2179.3,1207.74L2251.84,1207.74L2251.84,1135.2Z"
                style={{ fillRule: "nonzero" }}
              />
            </g>
          </g>

          {/* Animation group 1 - smallest element (dot) */}
          <g
            transform="matrix(1.16079,0,0,1.98715,-145.633,14.8301)"
            style={{
              opacity:
                !isPlaying || (activeGroup !== null && activeGroup >= 1)
                  ? 1
                  : 0,
              transition: "opacity 0.2s ease-in-out",
            }}
          >
            <g id="anim-1">
              <rect x="1338.84" y="371.384" width="23.231" height="22.8" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
